import { useMemo } from 'react'
import { useTexture } from '@react-three/drei'
import { NoColorSpace, SRGBColorSpace, Texture } from 'three'
import { textureAsset } from '../assetStore'

const footstepEffectTextureUrls = [
    textureAsset.EffectRunFootsteps,
    textureAsset.EffectRunDust,
    textureAsset.EffectRunLeaves,
] as const

function configureTexture(texture: Texture, colorSpace: typeof NoColorSpace | typeof SRGBColorSpace) {
    texture.flipY = false
    texture.colorSpace = colorSpace
}

export function useFootstepEffectTextures() {
    const textures = useTexture([...footstepEffectTextureUrls])

    const [footprintTexture, dustTexture, leavesTexture] = textures

    configureTexture(footprintTexture, NoColorSpace)
    configureTexture(dustTexture, NoColorSpace)
    configureTexture(leavesTexture, SRGBColorSpace)

    return useMemo(() => ({
        footprintTexture,
        dustTexture,
        leavesTexture,
    }), [footprintTexture, dustTexture, leavesTexture])
}
